import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OperationTypeListPage" */
	'pages/intervention/OperationType/OperationTypeListPage'));

export default [{ component, exact: true, path: '/operation_types' }];